import type { RivalsBoardProps } from './RivalsBoard.types'

// Ranks the brand against its rivals in one space, with the brand row highlighted.
export function RivalsBoard({ board }: RivalsBoardProps) {
  const max = board[0]?.count || 1

  return (
    // p-0.5 keeps the brand row's ring clear of a clipping overflow-hidden parent.
    <ul className="flex flex-col gap-1.5 p-0.5">
      {board.map((entry, i) => (
        <li
          key={entry.name}
          className={`grid grid-cols-[1.5rem_1fr_auto] items-center gap-3 rounded-lg px-2 py-1.5 text-sm ${
            entry.isBrand ? 'bg-yellow-400/15 ring-1 ring-yellow-500/40' : ''
          }`}
        >
          <span className="text-xs text-muted-foreground tabular-nums">
            {i + 1}
          </span>

          <span className="min-w-0">
            <span
              className={`truncate ${entry.isBrand ? 'font-semibold text-yellow-700 dark:text-yellow-300' : ''}`}
            >
              {entry.name}
              {entry.isBrand && (
                <span className="ml-1.5 text-[10px] uppercase tracking-wider text-yellow-700/80 dark:text-yellow-400/80">
                  you
                </span>
              )}
            </span>
            <span
              className={`mt-1 block h-1 rounded-full ${entry.isBrand ? 'bg-yellow-500/60' : 'bg-primary/30'}`}
              style={{ width: `${Math.round((entry.count / max) * 100)}%` }}
            />
          </span>

          <span className="text-xs text-muted-foreground tabular-nums">
            {entry.count}
          </span>
        </li>
      ))}
    </ul>
  )
}
